<template>
  <div id="my-strictly-unique-vue-image-lightbox-carousel" style="text-align: center;" v-if="this.images">
    <!--<button @click="openLightbox">Open Lightbox</button>-->
    <vue-image-lightbox-carousel
      ref="lightbox"
      :showPPT="selectedPPT"
      :show="playPpt"
      @close="setPlayPpt"
      :images="images"
      @change="changeImage"
      :showCaption="showCaption"
      :showThumbs="showThumbs"
      >
    </vue-image-lightbox-carousel>
  </div>
</template>
<script>
import VueImageLightboxCarousel from 'vue-image-lightbox-carousel'
import eventAPI from "@/api/event.js";
import courseAPI from "@/api/course.js";

export default {
  name: "PptPlayer",
  components: {
    VueImageLightboxCarousel
  },
  data() {
    return {
      id: this.$route.params.id,
      startTime: 0,
      isPlaying: false,
      confirmStart: "Do you want to carry on where you left off?",
      firstTime: true,
      showLightbox: false,
      showCaption: false,
      showThumbs: true,
      images: [{}]
        
        /*[
        {
          path: 'http://s3-eu-west-2.amazonaws.com/partner.staging.assets.improve.online/courses/training-material/e92a41ec-01be-423e-afa0-e36d6268259a-page0001.jpg',
          caption: 'a',
        },
        {
          path: 'http://s3-eu-west-2.amazonaws.com/partner.staging.assets.improve.online/courses/training-material/e92a41ec-01be-423e-afa0-e36d6268259a-page0002.jpg',
          caption: 'b',
        },
        {
          path: 'http://s3-eu-west-2.amazonaws.com/partner.staging.assets.improve.online/courses/training-material/e92a41ec-01be-423e-afa0-e36d6268259a-page0003.jpg',
          caption: 'c',
        },
        {
          path: 'https://i-thethao.vnecdn.net/2018/05/27/Screen-Shot-2018-05-27-at-7-1527379562_680x0.png',
          caption: 'd',
        },
      ]*/
    };
  },
  computed: {
    selectedPPT: function() {
      var slider = this.$store.getters.currentPpt.file.data.slider;
      this.images= [];
        for(let i = 0;i < slider.length; i++ ) {
            this.images.push({ path: slider[i] });
        }
    },
    playPpt: function() {
      return this.$store.getters.playPpt;
    }
  },
  methods: {
        openLightbox () {
          this.showLightbox = true
          //this.$refs.lightbox.showImage(0)
        },
        changeImage (index) {
          this.$refs.lightbox.showImage(index);
        },
        setPlayPpt(item) {
            this.$store.dispatch("setPlayPpt", false);
        }
    }
};
</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
/*.vue-lightbox-thumbnail-wrapper { display:none;}
[data-v-3f78f595]
*/
img.vue-lightbox-modal-image {
  max-height:calc(100vh - 10px) !important;
  height:100%;
  width:auto;
}
.vue-lightbox-content{
  max-width:calc(100vw - 30px) !important;
  margin-bottom: 20px !important;
}
.vue-lightbox-thumbnail .swiper-container {
  width:1px !important;
  height:1px !important;
}
.vue-lightbox-thumbnail-arrow {
  width:1px !important;
  height:1px !important;
}
.vue-lightbox-close {
  position:absolute;
  top:0;
  right:0;
  z-index: 999;
  margin-top:30px;
}
.vue-lightbox-arrow {
  background-color: #7bc8a3 !important;
  width:40px !important;
  height: 50px !important;
}
</style>